<template>
  <span v-if="!cardMode && addressData">
    <v-row v-if="isLocationEdit" :dense="dense">
      <v-col>
        <v-checkbox v-model="premise" :label="$t('basics.premise')" value="1">
        </v-checkbox>
      </v-col>
      <v-col>
        <v-checkbox
          v-model="premise"
          :label="$t('basics.address')"
          value="0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row v-if="isLocationEdit && premise == '1'" :dense="dense">
      <v-col>
        <v-combobox
          v-model="addressData.premise"
          :items="premises"
          :label="$t('basics.premise')"
          variant="outlined"
          item-title="name"
          item-value="name"
          return-object
          :rules="[validObject]"
          :readonly="readonly"
        ></v-combobox>
      </v-col>
    </v-row>

    <v-row v-if="!isLocationEdit || (isLocationEdit && premise == '0')" :dense="dense">
      <v-col cols="9" v-if="!isBirthplace">
        <v-text-field
          variant="outlined"
          flat
          :label="$t('basics.street') + '*'"
          :rules="[requiredRule, max120]"
          v-model="addressData.street"
          :readonly="readonly"
        >
        </v-text-field>
      </v-col>
      <v-col cols="3" v-if="!isBirthplace">
        <v-text-field
          variant="outlined"
          flat
          :label="$t('basics.housingNumber')"
          :rules="[max10]"
          v-model="addressData.housing_number"
          :readonly="readonly"
        >
        </v-text-field>
      </v-col>

      <v-col cols="12" v-if="!isBirthplace">
        <v-text-field
          variant="outlined"
          flat
          :label="$t('basics.additionalAddress')"
          :rules="[max256]"
          v-model="addressData.additional"
          :readonly="readonly"
        >
        </v-text-field>
      </v-col>

      <v-col cols="12" v-if="!isBirthplace">
        <v-text-field
          variant="outlined"
          flat
          :label="$t('basics.additionalAddress') + ' ' + 2"
          :rules="[max256]"
          v-model="addressData.additional2"
          :readonly="readonly"
        >
        </v-text-field>
      </v-col>
    </v-row>

    <v-row
      v-if="
        !isBirthplace &&
        addressData &&
        addressData.city &&
        (!isLocationEdit || (isLocationEdit && premise == '0'))
      "
    >
      <v-col :cols="bigCols">
        <v-combobox
          variant="outlined"
          flat
          :label="$t('basics.zipcode') + '*'"
          :rules="[requiredRule]"
          :items="filteredZipcodes"
          v-model="addressData.city.zip_code"
          no-filter
          :return-object="false"
          :readonly="readonly"
          @update:search="fetchCitiesByZipcode"
          @update:modelValue="setCityName"
        >
          <template v-slot:item="{ props, item }">
            <v-list-item v-bind="props" class="pa-2" title="">
                <span v-if="item.value.zip_code">
                  {{ item.value.zip_code }}
                </span>
                <span v-else-if="item.value.key">
                  {{ item.value.key }}
                </span>
                <span v-else>
                  {{ item.value }}
                </span>
            </v-list-item>
          </template>
          <template v-slot:selection="{ item }">
            <span v-if="item.raw && item.raw.key">
              {{ item.raw.key }}
            </span>
            <span v-else-if="item.raw.zip_code">
              {{ item.raw.zip_code }}
            </span>

            <span v-else>
              {{ item.raw }}
            </span>
          </template>
        </v-combobox>
      </v-col>

      <v-col :cols="bigCols">
        <v-combobox
          v-if="addressData.city && addressData.city.zip_code"
          variant="outlined"
          flat
          :label="$t('basics.city') + '*'"
          :rules="[requiredRule]"
          :items="filteredCityNames"
          v-model="addressData.city.name"
          no-filter
          item-value="name"
          item-title="name"
          :return-object="false"
          :readonly="readonly"
        >
        </v-combobox>

        <v-combobox
          v-if="addressData.city && !addressData.city.zip_code"
          variant="outlined"
          flat
          :label="$t('basics.city') + '*'"
          no-filter
          item-value="name"
          item-title="name"
          :disabled="true"
          :readonly="readonly"
        >
        </v-combobox>
      </v-col>

      <v-col :cols="bigCols">
        <v-combobox
          v-if="addressData.city && addressData.city.name && addressData.city.zip_code"
          :readonly="readonly"
          :label="$t('basics.country') + '*'"
          :rules="[requiredRule, validObject]"
          :items="countries"
          item-title="name"
          item-value="country"
          :return-object="true"
          variant="outlined"
          v-model="addressData.city.country"
        >
        </v-combobox>
        <v-combobox
          v-if="!addressData.city || !addressData.city.name || !addressData.city.zip_code"
          :readonly="readonly"
          :label="$t('basics.country') + '*'"
          :disabled="true"
          :items="countries"
          item-title="name"
          item-value="country"
          :return-object="true"
          variant="outlined"
        >
        </v-combobox>
      </v-col>
    </v-row>

    <v-row v-else-if="isBirthplace && !isLocationEdit || (isLocationEdit && premise == '0')">
      <v-col :cols="smallCols">
        <v-combobox
          variant="outlined"
          flat
          :label="$t('basics.birthPlace') + '*'"
          :rules="[requiredRule]"
          :items="cities"
          v-model="addressData.city"
          no-filter
          :return-object="true"
          :readonly="readonly"
          @update:search="fetchBirthplaceByName"
          @update:modelValue="setCountry"
        >
          <template v-slot:item="{ props, item }">
            <v-list-item v-bind="props" class="pa-2" title="">
              <span v-if="item.raw.name">
                {{ item.raw.name }}
              </span>
            </v-list-item>
          </template>
          <template v-slot:selection="{ item }">
            <span v-if="item.raw && item.raw.name">
              {{ item.raw.name }}
            </span>
          </template>
        </v-combobox>
      </v-col>

      <v-col :cols="smallCols">
        <v-combobox
          v-if="addressData.city"
          :readonly="readonly"
          :label="$t('basics.birthCountry') + '*'"
          :rules="[requiredRule, validObject]"
          :items="countries"
          item-title="name"
          item-value="country"
          return-object
          variant="outlined"
          v-model="addressData.city.country"
        >
        </v-combobox>

        <v-combobox
          v-if="!addressData || !addressData.city"
          :readonly="readonly"
          :label="$t('basics.birthCountry') + '*'"
          :rules="[requiredRule, validObject]"
          :items="countries"
          item-title="name"
          item-value="country"
          return-object
          variant="outlined"
          :disabled="true"
        >
        </v-combobox>
      </v-col>
    </v-row>
  </span>
  <span v-else>
    <v-card
      v-if="addressData"
      flat
      style="background-color: rgb(var(--v-theme-background))"
      @click="showEdit"
    >
      <v-container fluid>
        <v-row>
          <v-col>
            <v-container fluid class="pa-0">
              <v-row>
                <v-col
                  cols="auto"
                  class="pb-0"
                  v-if="!isBirthplace && addressData.street"
                >
                  {{ addressData.street }} {{ addressData.housing_number }}
                </v-col>
                <v-col cols="auto" class="pb-0" v-else-if="!isBirthplace"
                  ><i>{{ $t("messages.noStreet") }}</i>
                </v-col>
              </v-row>
              <v-row v-if="addressData.additional && !isBirthplace">
                <v-col class="pb-0">
                  {{ addressData.additional }}
                </v-col>
              </v-row>
              <v-row v-if="addressData.additional2 && !isBirthplace">
                <v-col class="pb-0">
                  {{ addressData.additional2 }}
                </v-col>
              </v-row>
              <v-row v-if="addressData.city && addressData.city.name">
                <v-col cols="auto" v-if="!isBirthplace">
                  {{ addressData.city.zip_code }}
                </v-col>
                <v-col cols="auto">
                  {{ addressData.city.name }}
                </v-col>
                <v-col cols="auto" v-if="addressData.city.country">
                  {{ addressData.city.country.name }}
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="auto">
                  <i>{{ $t("messages.noCity") }}</i>
                </v-col>
              </v-row>
            </v-container>
          </v-col>

          <v-spacer />
          <v-col cols="auto">
            <v-icon class="hoverable icon-transparency">mdi-pencil</v-icon>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </span>
</template>

<script>
export default {
  name: "addressComponent",

  props: {
    addressData: { default: {} },
    isBirthplace: { default: false },
    isLocationEdit: { default: false },
    dense: { default: false },
    required: {
      default: true,
    },
    autosave: { default: false },
    showPremise: { default: false },
    readonly: { default: false },
    cardMode: { default: false },
  },

  emits: ["update", "showEdit"],

  data() {
    return {
      cities: [],
      countries: [],
      premise: "0",

      premises: [],

      cityName: undefined,

      requiredRule: (v) => !!v || !this.required || this.$i18n.t("messages.required"),
      max9: (v) => !v || v.length <= 9 || this.$i18n.t("messages.tooLong", { value: 9 }),
      max90: (v) =>
        !v || v.length <= 90 || this.$i18n.t("messages.tooLong", { value: 90 }),
      max256: (v) =>
        !v || v.length <= 256 || this.$i18n.t("messages.tooLong", { value: 256 }),
      max10: (v) =>
        !v || v.length <= 10 || this.$i18n.t("messages.tooLong", { value: 10 }),
      max120: (v) =>
        !v || v.length <= 120 || this.$i18n.t("messages.tooLong", { value: 120 }),

      validObject: (value) =>
        !value ||
        typeof value == "object" ||
        this.$i18n.t("messages.validSelectionrequired"),
    };
  },

  computed: {
    filteredZipcodes() {
      if (!this.cities) {
        return [];
      }

      let zipcodes = {};

      for (let i = 0; i < this.cities.length; i++) {
        if (!zipcodes[this.cities[i].zip_code]) {
          zipcodes[this.cities[i].zip_code] = [];
        }

        let found = false;
        for (let j = 0; j < zipcodes[this.cities[i].zip_code].length; j++) {
          if (zipcodes[this.cities[i].zip_code][j].name == this.cities[i].name) {
            found = true;
            break;
          }
        }

        if (!found) {
          zipcodes[this.cities[i].zip_code].push(this.cities[i]);
        }
      }

      let temp = [];
      for (let i in zipcodes) {
        temp.push({ key: i, cities: zipcodes[i] });
      }

      return temp;
    },
    filteredCityNames() {
      if (!this.addressData.city || !this.addressData.city.zip_code) {
        return [];
      }

      for (let i = 0; i < this.filteredZipcodes.length; i++) {
        let key = this.addressData.city.zip_code;
        if (key.key) {
          //string vs object issues
          key = key.key;
        }

        if (this.filteredZipcodes[i].key == key) {
          return this.filteredZipcodes[i].cities;
        }
      }

      return [];
    },
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
    bigCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 12;
        case "lg":
          return 12;
        case "xl":
          return 6;
        case "xxl":
          return 6;
        default:
          return 6;
      }
    },
    smallCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 6;
        case "lg":
          return 6;
        case "xl":
          return 6;
        case "xxl":
          return 6;
        default:
          return 6;
      }
    },
  },

  watch: {
    adressData: {
      handler: function () {
        if (!this.addressData) {
          this.addressData = {};
        }
        if (!this.addressData.city) {
          this.addressData.city = {name: ""};
        }
      },
      deep: true,
    },
    showPremise() {
      if (!this.showPremise) {
        this.premise = "0";
        this.addressData.usePremise = false;
      } else {
        this.premise = "1";
        this.addressData.usePremise = true;
      }
    },
    premise() {
      if (this.premise == 1) {
        this.addressData.usePremise = true;
        this.fetchPremises();
      } else {
        this.addressData.usePremise = false;
        this.fetchPremises();
      }
    },
  },

  methods: {
    setCityName(zipCode) {
      if (zipCode && zipCode.cities && zipCode.cities.length == 1) {
        this.addressData.city.name = zipCode.cities[0].name;
        this.addressData.city.country = zipCode.cities[0].country;
        if(!this.addressData.city.country){
          for(let i = 0; i < this.countries.length; i++){
            if(this.countries[i].name == "Deutschland"){
              this.addressData.city.country = this.countries[i]
            }
          }
        }

        this.$forceUpdate();
      }
    },
    setCountry() {
      if(typeof this.addressData.city == "string"){
        this.addressData.city = { name: this.addressData.city}
      }
      if (this.addressData && this.addressData.city && this.addressData.city.country) {
        this.addressData.country = this.addressData.city.country;
      }
    },
    fetchPremises() {
      this.axios
        .get(this.axios.defaults.baseURL + "ressource/premises/?size=10000")
        .then((resp) => {
          this.premises = resp.data.results;
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          this.loading = false;
        });
    },

    fetchCountries() {
      this.axios
        .get(this.axios.defaults.baseURL + "localization/countries/")
        .then((resp) => {
          this.countries = resp.data;
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    update() {
      if (!this.autosave) {
        return;
      }
      this.$emit("update");
    },
    fetchBirthplaceByName(val) {
      if (val.length > 1) {
        this.axios
          .get(
            this.axios.defaults.baseURL + "localization/cities/by/name/?bp=1&city=" + val
          )
          .then((resp) => {
            this.cities = resp.data.results;
          })
          .catch((e) => {
            console.log(e);
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          });
      }
    },
    fetchCitiesByZipcode(val) {
      if (val.length > 1) {
        this.axios
          .get(
            this.axios.defaults.baseURL +
              "localization/cities/by/zipcode/?zip_code=" +
              val
          )
          .then((resp) => {
            this.cities = resp.data.results;
          })
          .catch((e) => {
            console.log(e);
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          });
      }
    },
    showEdit() {
      this.$emit("showEdit");
    },
  },

  mounted() {
    setTimeout(() => {
      setTimeout(() => {
        this.fetchCountries();
      }, 300);

      if (!this.addressData) {
        this.addressData = {};
      }

      if (!this.addressData.city) {
        this.addressData.city = {name: ""};
      }
    }, 200);
  },
};
</script>
